"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var a=a=>({checkboxRoot:{position:"relative"},error:{bottom:a.spacing(-3),position:"absolute",right:0}});exports.default=a
//# sourceMappingURL=styles.js.map
